module.exports = __webpack_public_path__ + "static/media/piper-bg-blue.2772d3f4.svg";